export enum ResourceTypes {
  TEAM = 'team',
  SHAREPOINT = 'sharepoint',
  RIS = 'ris',
  SERVER = 'server',
  BOOKINGS = 'bookings',
}
